import Api  from './Api'
import axios from 'axios'
import translateFilters from '../utils/translateFilters'

class CandidatesApi extends Api {
    async list(deleted = false, filters = {}){
        const request = async () => await axios.get(this.generateAbsolutePath(`aceptados${deleted ? '/eliminados' : ''}`), { params: translateFilters(filters) });
            
        const { data } = await this.perform(request);

        return data;
    }

    async store(data){
        const request = async () => await axios.post(this.generateAbsolutePath('inscripcion'), data);

        await this.perform(request);
    }

    async get(controlNumber){
        const request = async () => await axios.get(this.generateAbsolutePath(`inscripcion/${controlNumber}`));

        const { data } = await this.perform(request);

        return data;
    }

    async next(controlNumber){
        const request = async () => await axios.get(this.generateAbsolutePath(`inscripcion/${controlNumber}/siguiente`));

        const { data } = await this.perform(request);

        return data;
    }

    async block(controlNumber){
        const request = async () => await axios.post(this.generateAbsolutePath(`inscripcion/${controlNumber}/bloquear`));

        const { data } = await this.perform(request);

        return data;
    }

    async enroll(controlNumber, data = {}){
        const request = async () => await axios.post(this.generateAbsolutePath(`inscripcion/${controlNumber}/inscribir`), data);

        await this.perform(request);
    }

    async resendEnrollmentEmail(controlNumber){
        const request = async () => await axios.post(this.generateAbsolutePath(`inscripcion/${controlNumber}/reenviar-notificacion-de-inscripcion`));

        await this.perform(request);
    }

    async setNss(slug, nss){
        const request = async () => await axios.put(this.generateAbsolutePath(`aceptados/${slug}/numero-de-seguro-social`), { numero_de_seguro_social: nss });

        await this.perform(request);
    }

    async update(controlNumber, data){
        const request = async () => await axios.put(this.generateAbsolutePath(`inscripcion/${controlNumber}`), data);

        await this.perform(request);
    }

    async delete(slug){
        const request = async () => await axios.delete(this.generateAbsolutePath(`aceptados/${slug}`));

        await this.perform(request);
    }

    async restore(slug){
        const request = async () => await axios.put(this.generateAbsolutePath(`aceptados/eliminados/${slug}/reactivar`));

        await this.perform(request);
    }
}

export default CandidatesApi;